import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import * as apiUtil from "../../util/apiUtil";
import Loading from "../../component/loading/Loading";

const GoogleAuthCallbackPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const query = new URLSearchParams(location.search);
        const code = query.get('code');
        const error = query.get('error');

        if (error) {
            alert("Google 연동 중 오류가 발생했습니다: " + error);
            navigate('/intro');
            return;
        }

        if (code) {
            // 백엔드로 코드 전송
            apiUtil.asyncRequest({
                url: '/api/auth/google/callback',
                method: apiUtil.requestMethod.POST,
                data: {
                    code: code,
                    redirectUri: window.location.origin + '/auth/google/callback'
                },
                setLoading: setLoading,
                success: (result) => {
                    alert("Google 계정이 성공적으로 연동되었습니다.");
                    navigate('/form/list');
                },
                redirect_url: window.location.origin + '/form/list'
            });
        }
    }, [location, navigate]);

    return (
        <React.Fragment>
            <Loading loading={loading} />
            <div className="container-xxl d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <h3>Google 계정 연동 처리 중...</h3>
            </div>
        </React.Fragment>
    );
};

export default GoogleAuthCallbackPage;
